import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class CommonValidators {
  
  static requiredTrim(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return { required: true };
      }
      
      const value = typeof control.value === 'string' ? control.value.trim() : control.value;
      
      if (value === '' || value === null || value === undefined) {
        return { required: true };
      }
      
      return null;
    };
  }

  static decimalRate(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null;
      }
      
      const value = control.value.toString().trim();
      
      if (value === '') {
        return null;
      }
      
      const regex = /^-?\d+(\.\d+)?$/;

      if (!regex.test(value)) {
        return { invalidRate: true };
      }

      const parts = value.split('.');
      const integerDigits = parts[0].replace('-', '').length;
      const decimalDigits = parts[1]?.length || 0;

      if (integerDigits > 12 || decimalDigits > 6) {
        return { invalidRate: true };
      }
      
      return null;
    };
  }

    static noFutureDate(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null;
      }
      
      try {
        const selectedDate = new Date(control.value);
        const today = new Date();
        
        if (isNaN(selectedDate.getTime())) {
          return null; 
        }
        
        selectedDate.setHours(0, 0, 0, 0);
        today.setHours(0, 0, 0, 0);
        
        if (selectedDate > today) {
          return { futureDate: true };
        }
        
        return null;
      } catch (error) {
        return null;
      }
    };
  }

  static year(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null;
      }
      
      const value = control.value.toString().trim();
      
      if (value === '') {
        return null;
      }
      
      if (!/^\d+$/.test(value)) {
        return { notNumeric: true };
      }
      
      if (value.length !== 4) {
        return { invalidYearLength: true };
      }
      
      const yearValue = parseInt(value, 10);
      
      const min = 2000;
      if (yearValue < min) {
        return { yearTooLow: { min } };
      }
      
      const max = new Date().getFullYear() + 1;
      if (yearValue > max) {
        return { yearTooHigh: { max } };
      }
      
      return null;
    };
  }

  static dateFormat(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null;
      }

      const value = control.value;

      if (value instanceof Date) {
        return isNaN(value.getTime()) ? { invalidDate: true } : null;
      }

      const strValue = value.toString().trim();

      if (strValue === '') {
        return null;
      }

      let year: number, month: number, day: number;

      if (/^\d{8}$/.test(strValue)) {
        year = parseInt(strValue.substring(0, 4), 10);
        month = parseInt(strValue.substring(4, 6), 10);
        day = parseInt(strValue.substring(6, 8), 10);
      } else if (/^\d{4}-\d{2}-\d{2}$/.test(strValue)) {
        const parts = strValue.split('-');
        year = parseInt(parts[0], 10);
        month = parseInt(parts[1], 10);
        day = parseInt(parts[2], 10);
      } else {
        return { invalidDate: true };
      }

      const date = new Date(year, month - 1, day);
      if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
        return { invalidDate: true };
      }

      return null;
    };
  }

  static dateRangeValidator(): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const startDate = group.get('startDate')?.value;
    const endDate = group.get('endDate')?.value;

    if (!startDate || !endDate) {
      return null;
    }

    const start = new Date(startDate);
    const end = new Date(endDate);

    return start > end ? { dateRangeInvalid: true } : null;
  };
}

  
}